module.exports = __webpack_public_path__ + "static/mossoro-c03dc9ba1b5acae7359a76b45e060d0f.png";